export const PROJECT_MODULE_NAME = "project";
